import React, { Fragment, useRef, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { Page } from 'components/layout/panel/Page/Page';
import { Combined } from 'components/polls/Results/Combined/Combined';
import { Recipients } from 'components/polls/Results/Recipients/Recipients';
import { ResponsesContainer } from 'components/polls/Results/Responses/ResponsesContainer';
import { ResultsContainer } from 'components/polls/Results/ResultsContainer';
import { useNotification, useTranslator } from 'components/shared/hooks';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import {
  ROUTE_POLLS_LIST,
  ROUTE_POLLS_RESULTS,
  ROUTE_POLLS_RESULTS_RECIPIENTS,
  ROUTE_POLLS_RESULTS_RESPONSES,
} from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';

export const ResultsView: React.FC = () => {
  const ref = useRef<HTMLDivElement>();
  const trans = useTranslator();
  const { info } = useNotification();
  const [printMode, setPrintMode] = useState<boolean>(false);
  const { id: pollId } = useParams<{ id: string }>();

  const handlePrint = useReactToPrint({
    content: () => ref.current,
    pageStyle: 'margin-print',
    onBeforeGetContent() {
      info('POLLS.RESULTS.PRINTING', {}, { autoHideDuration: 2000 });
      setPrintMode(true);
      return new Promise((resolve) => {
        setTimeout(() => resolve(true), 2000);
      });
    },
    onAfterPrint() {
      setPrintMode(false);
    },
  });

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.POLLS.POLLS_LIST')} to={ROUTE_POLLS_LIST} />
      <Breadcrumb label={trans('BREADCRUMB.POLLS.POLL_RESULTS')} static />

      <Page title={trans('POLLS.RESULTS.TITLE')}>
        <ResultsContainer pollId={pollId}>
          {(pollId, pollResults, recipients) => (
            <Routes>
              <Route
                path={relativePath(ROUTE_POLLS_RESULTS, ROUTE_POLLS_RESULTS)}
                element={
                  <Combined
                    pollId={pollId}
                    results={pollResults.results}
                    pollName={pollResults.name}
                    printMode={printMode}
                    setPrintMode={setPrintMode}
                    print={handlePrint}
                    ref={ref}
                  />
                }
              />
              <Route
                path={relativePath(ROUTE_POLLS_RESULTS_RESPONSES, ROUTE_POLLS_RESULTS)}
                element={<ResponsesContainer pollId={pollId} responsesIds={pollResults.responses} />}
              />
              <Route
                path={relativePath(ROUTE_POLLS_RESULTS_RECIPIENTS, ROUTE_POLLS_RESULTS)}
                element={<Recipients recipients={recipients} />}
              />
            </Routes>
          )}
        </ResultsContainer>
      </Page>
    </Fragment>
  );
};
